import Cookies from 'js-cookie'
import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router'
import { cn } from '@/libs/utils'
import { UserServiceUserType } from '@/types/user'
import { useAuth } from '@/stores/authStore'
import { SearchProvider } from '@/context/search-context'
import { SidebarProvider } from '@/components/ui/sidebar'
import { ProtectedRoute } from '@/components/auth/protected-route'
import { AppSidebar } from '@/components/layout/app-sidebar'

export const Route = createFileRoute('/_authenticated')({
  component: RouteComponent,
})

function RouteComponent() {
  const auth = useAuth()
  const defaultOpen = Cookies.get('sidebar:state') !== 'false'

  // If user is admin, redirect to admin routes
  if (auth.user?.type === UserServiceUserType.Admin) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return <Navigate to='/admin/' replace />
  }

  // If user is agency, redirect to admin routes (same as admin)
  if (auth.user?.type === UserServiceUserType.Agency) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return <Navigate to='/admin/' replace />
  }

  return (
    <ProtectedRoute>
      <SearchProvider>
        <SidebarProvider defaultOpen={defaultOpen}>
          <AppSidebar />
          <div
            id='content'
            className={cn(
              'ml-auto w-full max-w-full',
              'peer-data-[state=collapsed]:w-[calc(100%-var(--sidebar-width-icon)-1rem)]',
              'peer-data-[state=expanded]:w-[calc(100%-var(--sidebar-width))]',
              'transition-[width] duration-200 ease-linear',
              'flex h-svh flex-col',
              'group-data-[scroll-locked=1]/body:h-full',
              'group-data-[scroll-locked=1]/body:has-[main.fixed-main]:h-svh'
            )}
          >
            <Outlet />
          </div>
        </SidebarProvider>
      </SearchProvider>
    </ProtectedRoute>
  )
}
